import React from 'react';
import type { Dispatch } from 'react';

import { CheckboxSelect } from '@atlaskit/select';
import type { OptionType, ValueType } from '@atlaskit/select';

import type { FilterKeys } from './filtersDefinitions.ts';
import {
	FilterHeaderCompiled,
	InputContainerCompiled,
	SelectContainerCompiled,
} from './presentationalComponents.tsx';
interface CheckboxSelectOptions {
	label: string;
	value: string;
}

interface CheckboxFilterProps {
	filterKey: FilterKeys;
	options: CheckboxSelectOptions[];
	label: string;
	inputId: string;
	filterDispatch: Dispatch<any>;
	selectedValues: CheckboxSelectOptions[];
}

export const CheckboxSelectFilter = ({
	options,
	filterKey,
	label,
	inputId,
	filterDispatch,
	selectedValues,
}: CheckboxFilterProps) => {
	const onChange = (selected: ValueType<OptionType, true>) => {
		filterDispatch({
			type: filterKey,
			payload: selected.map((x: any) => x.value.toString()),
		});
	};

	return (
		<InputContainerCompiled data-testid={inputId}>
			<FilterHeaderCompiled htmlFor={inputId}>{label}</FilterHeaderCompiled>
			<SelectContainerCompiled>
				<CheckboxSelect
					inputId={inputId}
					options={options}
					value={selectedValues}
					isSearchable={false}
					onChange={onChange}
					testId={inputId}
					classNamePrefix="react-select"
				/>
			</SelectContainerCompiled>
		</InputContainerCompiled>
	);
};
